import { ErrorMessage, Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import moment from "moment";
import * as Yup from "yup";
import * as Action from "../../../applicant/_redux/applicantActions";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";
import { useParams } from "react-router-dom";
import { Checkbox, DatePicker, Tag } from "antd";

const _init = {
  training_title: "",
  institution_name: "",
  country_id: "",
  year: 0,
  month: 0,
  day: 0,
  start_date: "",
  end_date: "",
  modality: "",
  skill: [],
};

const modality = [
  {
    value: "In-Person",
    label: "In-Person",
  },
  {
    value: "Hybrid",
    label: "Hybrid",
  },
  {
    value: "Online",
    label: "Online",
  },
];

const Training = () => {
  const { id } = useParams();
  const [trainingData, setTrainingData] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [skillValues, setSkillValues] = useState({});

  const { trainingList, personalInfo, countryList } = useSelector(
    ({ applicant }) => ({
      trainingList: applicant.trainingList,
      countryList: applicant.countryList,
      personalInfo: applicant.personal_info,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(Action.getAllCountry());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(Action.getAllTrainingByApplicants(id));
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (trainingList && trainingList.length > 0) {
      const data = trainingList?.map((item) => {
        return {
          training_title: item.hrms_training__training_title,
          institution_name: item.hrms_training__institution_name,
          country_id: item.hrms_training__country_id,
          duration: item.hrms_training__duration,
          modality: item.hrms_training__modality ?? "",
          skill: item.hrms_training__skill
            ? JSON.parse(item.hrms_training__skill)
            : [],
          start_date: item.hrms_training__start_date
            ? moment(item.hrms_training__start_date)
            : null,
          end_date: item.hrms_training__end_date
            ? moment(item.hrms_training__end_date)
            : null,
        };
      });
      setTrainingData({ list: data });
    } else {
      // setTrainingData({ list: [_init] });
      setTrainingData({ list: [] });
    }
  }, [trainingList]);

  // Validation schema
  const validationSchema = Yup.object()
    .nullable()
    .shape({
      list: Yup.array().of(
        Yup.object()
          .nullable()
          .shape({
            training_title: Yup.string()
              .nullable()
              .required("training title is required"),
            // start_date: Yup.object().nullable().required("start date is required"),
            // end_date: Yup.object().nullable().required("end date is required"),

            start_date: Yup.date().nullable(),
            end_date: Yup.date().nullable(),

            institution_name: Yup.string()
              .nullable()
              .required("institution name is required"),
            country_id: Yup.number().required("country is required"),
            modality: Yup.string().required("modality is required"),
            duration: Yup.number().nullable(),
          })
      ),
    });

  const handleSaveProfile = async (values) => {
    const formData = values?.list?.map((item) => {
      return {
        training_title: item?.training_title,
        institution_name: item?.institution_name,
        country_id: item?.country_id,
        start_date: item?.start_date
          ? moment(item?.start_date).format("YYYY-MM-DD")
          : null,
        end_date: item?.end_date
          ? moment(item?.end_date).format("YYYY-MM-DD")
          : null,
        duration: item?.duration,
        applicant_id: id,
        modality: item?.modality,
        skill: JSON.stringify(item?.skill),
      };
    });
    if (id) {
      const apiUrl = "/hrms_training/store";
      // const apiUrl = 'http://localhost:6003/api/v1/hrms_training/store';
      await API.post(apiUrl, { applicant_id: id, trainings: formData })
        .then(async (res) => {
          if (res.data.success) {
            // await dispatch(Action.getAllTrainingByApplicants(id));
            // dispatch(Action.getApplicantPersonalInfo(id));
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Training"],
                  applicant_id: id,
                },
                async () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                  await dispatch(Action.getAllTrainingByApplicants(id));
                }
              )
            );
            swalSuccess("Training Information Updated Successfully!!");
            setLoading(false);
          } else {
            swalError("something went wrong");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setLoading(false);
    }
  };

  const handleDelete = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        const list = trainingData?.list;
        list.splice(index, 1);
        setTrainingData({ list: list });
      }
    });
  };
  const handleAdd = async (values) => {
    // const list = trainingData?.list;
    // let data = [...list, _init];
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setTrainingData({ list: data });
  };

  const handleInputChange = useCallback((value, index) => {
    setSkillValues((prev) => ({
      ...prev,
      [index]: value,
    }));
  }, []);

  const handleKeyPress = useCallback(
    (e, index, setFieldValue, values) => {
      if (e.key === "Enter") {
        e.preventDefault();

        const expertise = skillValues[index]?.trim();
        if (expertise) {
          const currentExpertise = values.list[index].skill || [];

          if (!currentExpertise.includes(expertise)) {
            const updatedExpertise = [...currentExpertise, expertise];
            setFieldValue(`list[${index}].skill`, updatedExpertise);
          }

          setSkillValues((prev) => ({
            ...prev,
            [index]: "",
          }));
        }
      }
    },
    [skillValues]
  );

  const handleSkillRemove = (skill, index, setFieldValue, values) => {
    const currentExpertise = values.list[index].skill || [];
    const updatedExpertise = currentExpertise.filter((item) => item !== skill);
    setFieldValue(`list[${index}].skill`, updatedExpertise);
  };

  const handleOnChangeNoTraining = (no_training) => {
    const api = `/hrms_applicant/${id}`;
    // const api = `http://localhost:6003/api/v1/hrms_applicant/${id}`;
    API.patch(api, { no_training })
      .then((res) => {
        if (res.data.success) {
          swalSuccess("Data updated successfully");
          if (no_training) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Training"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                  dispatch(Action.getAllTrainingByApplicants(id));
                }
              )
            );
          } else {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Training"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                  dispatch(Action.getAllTrainingByApplicants(id));
                }
              )
            );
          }
        } else {
          if (res.data.message) {
            swalError(res.data.message);
          } else {
            swalError("something went wrong");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        swalError("something went wrong");
      });
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={trainingData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Training Information</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].training_title`}
                            label={"Training Title"}
                            isRequired
                            value={item.training_title}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].training_title`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].training_title`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].institution_name`}
                            label={"Institution Name"}
                            isRequired
                            value={item.institution_name}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].institution_name`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].institution_name`}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].country_id`}
                            label={"Country"}
                            options={countryList}
                            isRequired
                            value={item.country_id}
                            onChange={(value) => {
                              setFieldValue(`list[${i}].country_id`, value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].country_id`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className=""> Start Date</label>
                          <DatePicker
                            style={{ width: "100%" }}
                            value={
                              item.start_date ? moment(item.start_date) : ""
                            }
                            onChange={(val, date) => {
                              setFieldValue(`list[${i}].start_date`, date);
                              setFieldValue(`list[${i}].end_date`, "");
                              if (val && item.end_date) {
                                let durationTime = moment(item.end_date).diff(
                                  moment(val),
                                  "months"
                                );
                                // var months = durationTime.asMonths();
                                // const averageDaysPerMonth = 30.44;
                                // const monthsDiff = Number(durationTime / averageDaysPerMonth).toFixed(2);
                                setFieldValue(
                                  `list[${i}].duration`,
                                  durationTime
                                );
                              }
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].start_date`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="">End Date</label>
                          <DatePicker
                            style={{ width: "100%" }}
                            value={item.end_date ? moment(item.end_date) : ""}
                            disabledDate={(current) => {
                              // If there is a start date, use it as the minimum selectable date for the end date.
                              // Otherwise, use the current date.
                              const startDate = item.start_date
                                ? moment(item.start_date)
                                : moment();
                              return (
                                current && current < startDate.startOf("day")
                              );
                            }}
                            onChange={(val, date) => {
                              setFieldValue(`list[${i}].end_date`, date);
                              if (val && item.start_date) {
                                let durationTime = moment(val).diff(
                                  moment(item.start_date),
                                  "months"
                                );
                                // var months = durationTime.asMonths();
                                // const averageDaysPerMonth = 30.44;
                                // const monthsDiff = Number(durationTime / averageDaysPerMonth).toFixed(2);
                                setFieldValue(
                                  `list[${i}].duration`,
                                  durationTime
                                );
                              }
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].end_date`} />
                          </div>
                        </div>
                        {/* <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].duration`}
                            label={"Duration (In Months)"}
                            disabled
                            value={item.duration}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].duration`,
                                e.target.value
                              );
                            }}
                          />

                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].duration`} />
                          </div>
                        </div> */}
                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].modality`}
                            label={"Modality"}
                            options={modality}
                            isRequired
                            value={item.modality}
                            onChange={(value) => {
                              setFieldValue(`list[${i}].modality`, value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].modality`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].skill`}
                            label={"Learning Area"}
                            value={skillValues[i] || ""}
                            onChange={(e) =>
                              handleInputChange(e.target.value, i)
                            }
                            onKeyPress={(e) =>
                              handleKeyPress(e, i, setFieldValue, values)
                            }
                            placeholder="Type an learning area and press Enter"
                          />
                          <div style={{ marginTop: 10 }}>
                            {item?.skill &&
                              item?.skill?.map((skill) => (
                                <Tag
                                  key={skill}
                                  closable
                                  onClose={() =>
                                    handleSkillRemove(
                                      skill,
                                      i,
                                      setFieldValue,
                                      values
                                    )
                                  }
                                >
                                  {skill}
                                </Tag>
                              ))}
                            <div className="text-danger">
                              <ErrorMessage name={`list[${i}].skill`} />
                            </div>
                            {/* {item?.area_of_expertise} */}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 mb-3 d-flex">
                          {i === values?.list?.length - 1 && (
                            <button
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={() => {
                                handleAdd(values);
                              }}
                              type="button"
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Training
                            </button>
                          )}
                          <button
                            className="btn btn-danger btn-sm  text-nowrap"
                            onClick={() => {
                              handleDelete(item.id, i);
                            }}
                            type="button"
                          >
                            <i
                              className="fa fa-minus  text-white"
                              aria-hidden="true"
                            ></i>
                            Remove Training
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {!values?.list?.length && (
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ display: "flex", gap: "2" }}
                >
                  {!personalInfo?.no_training && (
                    <button
                      className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                      onClick={() => {
                        handleAdd(values);
                      }}
                      type="button"
                    >
                      <i
                        className="fa fa-plus text-white"
                        aria-hidden="true"
                      ></i>
                      Add Training
                    </button>
                  )}
                  <div className="align-content-center">
                    <Checkbox
                      type="checkbox"
                      checked={personalInfo?.no_training}
                      id="no_training"
                      onChange={(e) => {
                        handleOnChangeNoTraining(e.target.checked ? 1 : 0);
                      }}
                    />
                    <label
                      className="form-check-label ml-2"
                      htmlFor="no_training"
                    >
                      <b>Don't have any training?</b>
                    </label>
                  </div>
                </div>
              </div>
            )}
            {!personalInfo?.no_training && (
              <div className="edit_btn_group d-flex modal-footer m-0 p-0">
                {/* <button className='btn btn-default mr-4' >Cancel</button> */}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Training;
